import { BFLType, ModuleTypeId } from "../../types/DBTables";
import { IGlobalData } from "../../types/globalData";
import { IBIMHandler } from "./bimHandler";
import { IModuleRound, IRoundHandler } from "../roundHandler";
//import { IModuleVattenburetSekundärsystem } from "../../types/ModuleDatas";

import bflHelper from "./bflHelper";
import { IBFModule, IBFResult, IKontrollResultRow, IKontrollResultRowDriftoptimering } from "../../types/BFL/Funktionskontroll";
import { bfv_J9 } from "./BFV_J9";
import { IModuleByggnadsdata, IModuleKylaVattenburet, IModuleLokaler, IModuleVattenburetSekundärsystem } from "../../types/ModuleDatas";
import { logAndNotifyError } from "../logger";

//todo -> make class?!
export const bfv_J6 = (): IBFModule => {
  const bfName = BFLType.BFV_J6;
  const getResult = (module: IModuleRound, bimHandler: IBIMHandler, roundHandler: IRoundHandler, globalData: IGlobalData): IBFResult => {
    //const moduleData: IModuleVattenburetSekundärsystem = module.data;

    const funktionsKontroller: IKontrollResultRow[] = [];
    const driftOptimeringar: IKontrollResultRowDriftoptimering[] = [];
    let dbg = {} as any;
    let error: any = undefined;

    const bH = bflHelper.bflHelper();

    try {
      //Todo: Vilken module är det?
      const bfJ9 = bfv_J9().getResult(module, bimHandler, roundHandler, globalData);
      const schablonBesparing = bfJ9.data.schablonBesparing;

      //Hittar kylen som betjänar störst gemensam yta
      const roundData = roundHandler.getRoundData();
      const kylSystemMedGemensamBetjäningsyta = roundData?.data.modules.filter(
        (m) => m.moduleTypeId === ModuleTypeId.KylaVattenburet && (m.data as IModuleKylaVattenburet).värmeSystemGemensamBetjäningsyta?.find((r) => r.värmeModulId === module.id)
      );
      let kylSystemStörstGemensamYta: IModuleRound | undefined = undefined;
      let ytaProcentSomBetjänasMedKomfortKyla = 0;
      if (kylSystemMedGemensamBetjäningsyta?.length) {
        for (var mi = 0; mi < kylSystemMedGemensamBetjäningsyta?.length; mi++) {
          const modKylSystem = kylSystemMedGemensamBetjäningsyta[mi];
          const gemensamBetjäningsytaAndel = (modKylSystem.data as IModuleKylaVattenburet).värmeSystemGemensamBetjäningsyta.find((g) => g.värmeModulId === module.id);
          if (gemensamBetjäningsytaAndel?.ytaAndel && gemensamBetjäningsytaAndel?.ytaAndel > ytaProcentSomBetjänasMedKomfortKyla) {
            kylSystemStörstGemensamYta = modKylSystem;
            ytaProcentSomBetjänasMedKomfortKyla = gemensamBetjäningsytaAndel.ytaAndel;
          }
        }
      }

      if (!kylSystemStörstGemensamYta) {
        return {
          bfName: BFLType.BFV_J4,
          funktionsKontroller: [],
          driftOptimeringar: [],
          note: "",
          error: error,
          debug: {},
          data: { ingenGemensamYta: true },
        };
      }

      //Module and datas
      const moduleKylsystemData: IModuleKylaVattenburet = kylSystemStörstGemensamYta?.data as IModuleKylaVattenburet;
      const byggnadsDataData: IModuleByggnadsdata | undefined = roundHandler.getRoundData()?.data.modules.find((m) => m.moduleTypeId === ModuleTypeId.Byggnadsdata)?.data;
      const moduleLokalerData = roundHandler.getRoundData()?.data.modules.find((m) => m?.moduleTypeId === ModuleTypeId.Lokaler)?.data as IModuleLokaler;
      const moduleVärmeSekundärData = module?.data as IModuleVattenburetSekundärsystem;

      //Grundvärden för BFL
      const j6ÄrvärdeFramledning = moduleVärmeSekundärData.framledningArvarde;
      const j6BörvärdeFramledning = moduleVärmeSekundärData.framledningBorvarde;
      const j6DifferensÄrvärde = j6ÄrvärdeFramledning - j6BörvärdeFramledning;

      const j6UtstyrningVärmeventil = moduleVärmeSekundärData.varmeventilUtstyrning / 100;
      const j6ÅrligEnergiTransmission = bimHandler.BIM_ÅrligBruttoTransmission();
      const j6VärmehuntensSystemandel = moduleVärmeSekundärData.värmeSystemandel / 100;
      const j6SchablonVärme = schablonBesparing;

      const j6ValdKylform = moduleKylsystemData.kylform;
      const kylformFaktorRow = globalData.Kyla.Kylform_Faktor.find((r) => r.Kylform === j6ValdKylform);

      const j6Kylfaktor = kylformFaktorRow?.Faktor as number;
      const j6SchablonEnergiKyla = bimHandler.BIM_Schablon_EnergiKyla;
      const j6YtaSomBetjänas = ytaProcentSomBetjänasMedKomfortKyla / 100;

      //TODO: Kan det vara olika resultat på stickprov komfortkyla aktiv?
      const stickProvVärmesystem = moduleLokalerData.stickprov.filter((s) => s.värmeSystem === module?.name);
      const j6KylaAktiv = stickProvVärmesystem[0].komfortKylaAktiv;
      const j6KylfaktorKylproduktion = kylformFaktorRow?.FJV as number;

      const byggnadArea = byggnadsDataData?.byggnadArea as number;
      //=byggnadArea*j6VärmehuntensSystemandel*j6YtaSomBetjänas*j6SchablonEnergiKyla/j6Kylfaktor
      const j6NormalEnergianvändning = (byggnadArea * j6VärmehuntensSystemandel * j6YtaSomBetjänas * j6SchablonEnergiKyla) / j6Kylfaktor;
      //=IF(j6KylaAktiv="Ja";(j6DifferensÄrvärde/3)*((j6ÅrligEnergiTransmission*j6VärmehuntensSystemandel*j6SchablonVärme*j6YtaSomBetjänas)-j6NormalEnergianvändning);0)
      const j6Överkonsumption =
        j6KylaAktiv === "Ja" ? (j6DifferensÄrvärde / 3) * (j6ÅrligEnergiTransmission * j6VärmehuntensSystemandel * j6SchablonVärme * j6YtaSomBetjänas) - j6NormalEnergianvändning : 0;
      //=IF(AND(j6UtstryrningVärmeventil=0;j6KylaAktiv="Ja");1;0)
      const j6VilkorFörFunktionskontroll = j6UtstyrningVärmeventil === 0 && j6KylaAktiv === "Ja" ? 1 : 0;

      //=IF(AND(j6VilkorFörFunktionskontroll=1;j6DifferensÄrvärde>=1,5);j6Överkonsumption;0)
      const j6kWhBrutto = j6VilkorFörFunktionskontroll === 1 && j6DifferensÄrvärde >= 1.5 ? j6Överkonsumption : 0;

      // const energiSlag = j6ValdKylform === "Absorptionskyla" ? "Kyla (FJV)" : kylformFaktorRow?.Energislag as string;
      // const kWHperYear = j6kWhBrutto > 0 ? j6kWhBrutto / j6Kylfaktor : undefined;
      let energiSlag: string;
      let energiSlagAbsorb: string;
      let kWHperYear: number | undefined;
      let kWHperYearAbsorb: number | undefined;

      if (j6ValdKylform === "Absorptionskyla") {
        energiSlag = "Kyla (FJV)";
        energiSlagAbsorb = "Absorptionskyla";
        kWHperYear = j6kWhBrutto > 0 && j6KylfaktorKylproduktion > 0 ? j6kWhBrutto / j6KylfaktorKylproduktion : undefined;
        kWHperYearAbsorb = j6kWhBrutto > 0 ? j6kWhBrutto / j6Kylfaktor : undefined;
      } else {
        energiSlag = kylformFaktorRow?.Energislag as string;
        energiSlagAbsorb = "";
        kWHperYear = j6kWhBrutto > 0 ? j6kWhBrutto / j6Kylfaktor : undefined;
        kWHperYearAbsorb = undefined;
      }

      const tabell1 = {
        j6ÄrvärdeFramledning,
        j6BörvärdeFramledning,
        j6DifferensÄrvärde,
        j6UtstryrningVärmeventil: j6UtstyrningVärmeventil,
        j6ÅrligEnergiTransmission,
        j6VärmehuntensSystemandel,
        j6SchablonVärme,
        j6ValdKylform,
        j6Kylfaktor,
        j6SchablonEnergiKyla,
        j6YtaSomBetjänas,
        j6KylaAktiv,
        j6KylfaktorKylproduktion,
        j6NormalEnergianvändning,
        j6Överkonsumption,
        j6VilkorFörFunktionskontroll,
        j6kWhBrutto,
        kWHperYear,
      };
      dbg = { tabell1 };

      let messageGenerated = false;

      //=IF(AND(j6VilkorFörFunktionskontroll=1;j6kWhBrutto>1);1;0)
      if (j6VilkorFörFunktionskontroll === 1 && j6kWhBrutto > 1) {
        messageGenerated = true;
        funktionsKontroller.push(roundHandler.getFunktionsKontroll(bfName, 1, kWHperYear, energiSlag));
        // funktionsKontroller.push({
        //   index: 1,
        //   kWhs: kWHperYear,
        //   energiSlag: energiSlag,
        //   message: globalData.Funktionskontroller.mapFunktionskontroller.BFVJ6_FKText1,
        // });
      }

      //=IF(AND(j6VilkorFörFunktionskontroll=1;j6kWhBrutto=0);1;0)
      // if (j6VilkorFörFunktionskontroll === 1 && j6kWhBrutto === 0) {
      //   messageGenerated = true;
      //   funktionsKontroller.push({
      //     index: 2,
      //     kWhs: kWHperYear,
      //     energiSlag: energiSlag,
      //     message: globalData.Funktionskontroller.mapFunktionskontroller.BFVJ6_FKText2,
      //   });
      // }

      //=IF(AND(j6KylaAktiv="Ja";j6UtstryrningVärmeventil>=0,005);1;0)
      // if (j6KylaAktiv === "Ja" && j6UtstyrningVärmeventil >= 0.005) {
      //   messageGenerated = true;
      //   funktionsKontroller.push({
      //     index: 3,
      //     kWhs: kWHperYear,
      //     energiSlag: energiSlag,
      //     message: globalData.Funktionskontroller.mapFunktionskontroller.BFVJ6_FKText3,
      //   });
      // }

      //=IF(AND(j6SchablonVärme=0;j6KylaAktiv="Nej");1;0)
      if (j6UtstyrningVärmeventil === 0 && j6KylaAktiv === "Nej") {
        messageGenerated = true;
        funktionsKontroller.push(roundHandler.getFunktionsKontroll(bfName, 4, kWHperYear, energiSlag));
        // funktionsKontroller.push({
        //   index: 4,
        //   kWhs: kWHperYear,
        //   energiSlag: energiSlag,
        //   message: globalData.Funktionskontroller.mapFunktionskontroller.BFVJ6_FKText4,
        // });
      }

      //=IF(AND(j6UtstryrningVärmeventil=0;j6KylaAktiv="Nej");1;0)
      // if (j6UtstyrningVärmeventil === 0 && j6KylaAktiv === "Nej") {
      //   messageGenerated = true;
      //   funktionsKontroller.push({
      //     index: 5,
      //     kWhs: kWHperYear,
      //     energiSlag: energiSlag,
      //     message: globalData.Funktionskontroller.mapFunktionskontroller.BFVJ6_FKText5,
      //   });
      // }

      if (!messageGenerated && j6ValdKylform === "Absorptionskyla") {
        funktionsKontroller.push(roundHandler.getFunktionsKontroll(bfName, 6, kWHperYearAbsorb, energiSlagAbsorb));
        // funktionsKontroller.push({
        //   index: 6,
        //   kWhs: kWHperYearAbsorb,
        //   energiSlag: energiSlagAbsorb,
        //   message: "",
        // });
      }
    } catch (ex: any) {
      logAndNotifyError(ex);
      error = ex.toString();
    }

    return {
      bfName,
      funktionsKontroller: bH.cleanFunktionsKontroller(funktionsKontroller),
      driftOptimeringar: bH.cleanDriftoptimeringar(driftOptimeringar),
      note: "",
      error,
      debug: dbg,
    };
  };

  return { getResult, bfName };
};

const dflt = { bfv_J6 };

export default dflt;
